"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _actionTypes = require("../actions/actionTypes");

var _asyncResource = _interopRequireDefault(require("./helpers/asyncResource"));

function portalDragAndDropAvailable() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actionTypes.RECEIVE_PORTAL_SETUP_STATUS:
      if (action.error !== true) {
        return action.payload;
      }

      return state;

    default:
      return state;
  }
}

var _default = (0, _asyncResource.default)(portalDragAndDropAvailable, {
  requestActions: [_actionTypes.REQUEST_PORTAL_SETUP_STATUS],
  responseActions: [_actionTypes.RECEIVE_PORTAL_SETUP_STATUS],
  invalidatingActions: []
});

exports.default = _default;
module.exports = exports.default;